import { useAuth0 } from "@auth0/auth0-react";
import { Box, Button, Typography } from "@mui/material";
import React from "react";
import { Colours } from "../assets/global/Theme-variable";
import LogoIcon from "../components/LogoIcon";

export default function NotRegistered() {
  const { logout } = useAuth0();
  const returnToLogIn = () => {
    logout({
      logoutParams: {
        returnTo: `${window.location.origin}`,
      },
    });
  };

  return (
    <Box
      sx={{
        flex: 1,
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <LogoIcon height={200} />
      <Typography sx={{ fontSize: 14, mt: 5 }}>
        Your email address could not be found in our system.
      </Typography>
      <Typography sx={{ fontSize: 14, mt: 2, textAlign: "center" }}>
        If you are a current user of MaxSuite, please contact GS Systems on
        <Typography sx={{ fontSize: 14, color: Colours.gsblue }}>
          support@gs-systems.co.uk
        </Typography>
        or
        <Typography sx={{ fontSize: 14, color: Colours.gsblue }}>
          0161 483 5595
        </Typography>
        to authorise this email address.
      </Typography>
      <Button onClick={returnToLogIn}>Return to log in</Button>
    </Box>
  );
}
